export const DIRECTORY_OPERATION_START = 'DIRECTORY_OPERATION_START';
export const DIRECTORY_OPERATION_END = 'DIRECTORY_OPERATION_END';

export const FETCH_DIRECTORY_PROJECTS = 'FETCH_DIRECTORY_PROJECTS';
export const FETCH_DIRECTORY_PROFESSIONS = 'FETCH_DIRECTORY_PROFESSIONS';

export const ADD_TO_DIRECTORY_ERROR_INITITATE = 'ADD_TO_DIRECTORY_ERROR_INITITATE';
export const ADD_TO_DIRECTORY_ERROR = 'ADD_TO_DIRECTORY_ERROR';

export const FETCH_DIRECTORY_PROGRESS_REPORT = 'FETCH_DIRECTORY_PROGRESS_REPORT';
export const FETCH_DIRECTORY_SERVICES_CHARGES = 'FETCH_DIRECTORY_SERVICES_CHARGES';
export const FETCH_DIRECTORY_SERVICES_CHARGES_GROUPS = 'FETCH_DIRECTORY_SERVICES_CHARGES_GROUPS';
export const FETCH_DIRECTORY_SERVICES_CHARGES_GROUP_DATA = 'FETCH_DEVELOPERS_SERVICES_CHARGES_GROUP_DATA';
